export default __webpack_public_path__ + "static/home_page_ordering-2640ed75624a6399bfa714e2c2bd9152.mp4";